export default {
    CONTRICAO: 1,
    QUEIMACAO: 2,
    COMPRESSAO: 3,
    PESO: 4,
    DOR_SURDA: 5,
    RETROESTERNAL: 6,
    MSE: 7,
    FACE: 8,
    PESCOCO: 9,
    DENTES: 10,
    INTER_ESCAPULAR: 11,
    EPIGASTRICA: 12,
    EXERCICIO: 13,
    EXCITACAO: 14,
    ESTRESSE: 15,
    FRIO: 16,
    REFEICOES_COPIOSAS: 17,
    DURACAO_DA_DOR: 18,
    HAS: 19,
    DM: 20,
    DISLIPIDEMIA: 21,
    HISTORIA_FAMILIAR: 22,
    IDADE_MAIOR_SESSENTA: 23,
    OBESIDADE: 24,
    TABAGISMO: 25,
    REVASCULARIZADO_PREVIO: 26,
}